import React, { type ReactNode } from 'react'
import { css, type SerializedStyles } from '@emotion/core'
import { Bleedable } from '@fs/zion-ui'
import { MARGIN_X_DEFAULT } from './common'
import { type PersonType } from '../types/general'
import { useMergeIsMobile } from '../providers/MergeLayoutProvider'

/** At mobile only the side facing the middle column divider gets padding, keeping the outer edges flush with the edge-to-edge card text. */
const mobileDividerGapCssMap: Partial<Record<PersonType, SerializedStyles>> = {
  duplicate: css`
    padding-inline-end: ${MARGIN_X_DEFAULT}px;
  `,
  survivor: css`
    padding-inline-start: ${MARGIN_X_DEFAULT}px;
  `,
}

type Props = {
  children: ReactNode
  personType: PersonType
}

/** Side padding for the merge column headings. Bleedable only supports symmetric side padding, hence the css map for the asymmetric mobile case. */
export default function ColumnHeadingPadding({ children, personType }: Props): JSX.Element {
  const isMobile = useMergeIsMobile()

  if (isMobile) {
    return <div css={mobileDividerGapCssMap[personType]}>{children}</div>
  }

  return <Bleedable sides={4}>{children}</Bleedable>
}
